import NewsApp from 'hb-react/frontoffice/apps/News/startup/NewsAppClient';
import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { createNewsAppConfig } from 'hb-react/shared/apps/Topics/containers/TopicNewsContainer/utils';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';

const TopicNewsContainer = () => {
  const topicContext = useTopicContext();
  const { currentUser } = useDefaultAppContexts();
  const { flagEvNewsRevamp } = useFeatureFlag();

  const config = createNewsAppConfig({
    currentUser,
    topicContext,
    flagEvNewsRevamp,
  });

  return <NewsApp config={config} />;
};

export default TopicNewsContainer;
